// Returns true for Space pressed while focus sits on a PrimeReact sortable header cell. PrimeReact would toggle sorting on that key — the quick-filter shortcut claims it in capture phase instead, so Space never sorts (JS-1060).
export const isSpaceOnSortableHeader = (event: KeyboardEvent): boolean => {
  if (event.code !== 'Space') return false;

  const target = event.target as HTMLElement | null;
  return Boolean(target?.closest?.('[data-p-sortable-column="true"]'));
};
